import React from 'react'
import {
  Header,
  Table,
  Message,
  Icon,
} from 'semantic-ui-react'
import {
  Link
} from 'react-router-dom'
import ScreenContainer from './ScreenContainer.js'
import Tier from './Tier.js'
import Mastery from './Mastery.js'
import OptionalSelectTableHeaderCell from './OptionalSelectTableHeaderCell.js'
import OptionalItemCounterCell from './OptionalItemCounterCell.js'
import OptionalItemSelectorCell from './OptionalItemSelectorCell.js'
import OptionalCompareTableHeaderCells from './OptionalCompareTableHeaderCells.js'
import OptionalCompareItemCells from './OptionalCompareItemCells.js'
import { areas } from './curriculum.js'


function buildTable(mode, selection, selections, comparisonMode, comparisonSelectionNames, onToggle) {
  let result = [];
  for (const area of areas) {
    result.push(
      <Table.Row warning key={area.id}>
        <Table.Cell collapsing>{area.id}</Table.Cell>
        <Table.Cell><Link to={"/area/"+area.id}><b>{area.name}</b></Link></Table.Cell>
        <Table.Cell collapsing></Table.Cell>
        <Table.Cell collapsing></Table.Cell>
        <OptionalItemCounterCell mode={mode} selection={selection} fqidPrefix={area.id} itemKind='outcomes'/>
        <OptionalCompareItemCells mode={mode} selections={selections} comparisonMode={comparisonMode} comparisonSelectionNames={comparisonSelectionNames} fqidPrefix={area.id} itemKind='outcomes'/>
      </Table.Row>
    );
    for (const unit of area.units) {
      result.push(
        <Table.Row key={unit.fqid}>
          <Table.Cell collapsing disabled>{unit.fqid}</Table.Cell>
          <Table.Cell><Link to={"/unit/"+unit.fqid}>{unit.name}</Link></Table.Cell>
          <Table.Cell collapsing></Table.Cell>
          <Table.Cell collapsing></Table.Cell>
          <OptionalItemCounterCell mode={mode} selection={selection} fqidPrefix={unit.fqid} itemKind='outcomes'/>
          <OptionalCompareItemCells mode={mode} selections={selections} comparisonMode={comparisonMode} comparisonSelectionNames={comparisonSelectionNames} fqidPrefix={unit.fqid} itemKind='outcomes'/>
        </Table.Row>
      );
      for (const outcome of unit.outcomes) {
        result.push(
          <Table.Row key={outcome.fqid}>
            <Table.Cell collapsing disabled>{outcome.id}</Table.Cell>
            <Table.Cell>{outcome.name}</Table.Cell>
            <Table.Cell collapsing textAlign='center'><Mastery mastery={outcome.mastery}/></Table.Cell>
            <Table.Cell collapsing textAlign='center'><Tier tier={outcome.tier}/></Table.Cell>
            <OptionalItemSelectorCell mode={mode} selection={selection} onToggle={onToggle} fqid={outcome.fqid}/>
            <OptionalCompareItemCells
              mode={mode}
              comparisonMode={comparisonMode}
              comparisonSelectionNames={comparisonSelectionNames}
              selections={selections}
              fqidPrefix={outcome.fqid}
            />
          </Table.Row>
        );
      }
    }
  }
  console.log(result);
  return result;
}

const Outcomes = ({mode, selection, selections, comparisonMode, comparisonSelectionNames, onToggle}) => {
  const rows = buildTable(mode, selection, selections, comparisonMode, comparisonSelectionNames, onToggle);
  return (
    <ScreenContainer mode={mode}>
      <Header as='h1'>All Learning Outcomes</Header>
      <Message warning>
        <Message.Header>
          <Icon name='warning sign'/>
          This page may be slow
        </Message.Header>
        <p>
          This page provides the list of all learning outcomes.
          It is too large to be rendered quickly,
          and thus may feel very sluggish.
          We kept it here because it can be useful to get an overview.
          We recommend you use the page hierarchy
          under <Link to='/areas'>Knowledge Areas</Link> and
          the <Link to='/search'>Search page</Link> for
          snappier performance.
        </p>
      </Message>

      <Table selectable compact='very' basic='very'>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell collapsing>
            </Table.HeaderCell>
            <Table.HeaderCell>
              Name
            </Table.HeaderCell>
            <Table.HeaderCell collapsing textAlign='center'>
              Mastery
            </Table.HeaderCell>
            <Table.HeaderCell collapsing textAlign='center'>
              Tier
            </Table.HeaderCell>
            <OptionalSelectTableHeaderCell mode={mode} selection={selection}/>
            <OptionalCompareTableHeaderCells
              mode={mode}
              selections={selections}
              comparisonMode={comparisonMode}
              comparisonSelectionNames={comparisonSelectionNames}
            />
          </Table.Row>
        </Table.Header>
        <Table.Body>
          { rows }
        </Table.Body>
      </Table>
    </ScreenContainer>
  );
}

export default Outcomes